import { memo } from 'react';
import { Stack, Typography, Card, Alert } from 'investira.react.components';
import { formats, validators } from 'investira.sdk';

const RecursoGarantidor = memo(props => {
  const { data } = props;
  // const [open, setOpen] = useState(false);

  const hasErro = data.response?.detalhe?.some(item => item.erro);
  const mensagemErro = hasErro ? data.response.detalhe.find(item => item.erro).erro : '';
  const hasRecursoGarantidor = !validators.isNull(
    data.response?.resumo.contabil.recurso_garantidor
  );

  return (
    <>
      <Card sx={{ flexGrow: 0, display: 'flex', minHeight: 0 }}>
        <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
          <Typography variant="caption" color="textPrimary" sx={{ fontWeight: 500 }}>
            Recurso Garantidor
          </Typography>
          <Stack direction="column" justifyContent="flex-end">
            {hasErro ? (
              <Stack mt={1}>
                <Alert severity="error">{mensagemErro}</Alert>
              </Stack>
            ) : (
              <Stack direction="row" justifyContent="space-between" alignItems="flex-end">
                <Typography variant="h5" color="textPrimary">
                  <b>
                    {hasRecursoGarantidor
                      ? formats.formatNumber(
                          data.response.resumo.contabil.recurso_garantidor,
                          2,
                          true,
                          true
                        )
                      : 'Ausente'}
                  </b>
                </Typography>
                {/* <Box
                  sx={{ width: '16px', height: '16px', cursor: 'pointer' }}
                  onClick={() => setOpen(true)}>
                  <Icon iconName={'others'} size={16} color="primary" />
                </Box> */}
              </Stack>
            )}
          </Stack>
        </Stack>
      </Card>
      {/* <Dialog open={open} onClose={() => setOpen(false)} maxWidth="lg">
        <DialogTitle>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            Recurso Garantidor por Carteira
            <IconButton color="primary" onClick={() => setOpen(false)}>
              <Icon iconName="cancel" size={21} />
            </IconButton>
          </Stack>
        </DialogTitle>

        <DialogContent sx={{ display: 'flex' }}>
          <RecursoGarantidorDetalhe data={data} />
        </DialogContent>
      </Dialog> */}
    </>
  );
});

export default RecursoGarantidor;
